import React, { FC, useEffect } from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { PrivateRoute } from 'routes/PrivateRoute';
import { CustomersList } from 'features/Customers/CustomersList';
import { CustomerDetails } from 'features/CustomerDetails/CustomerDetails';
import { FinalizeOrderList } from 'features/OrdersList/FinalizeOrderList';
import { LinkToOrderList } from 'features/OrdersList/LinkToOrderList';
import { TestReport } from 'features/OrdersList/TestReport/TestReport';
import { AppMenuDrawer } from 'components/AppMenu/AppMenuDrawer';
import { SimpleNavBar } from 'components/NavBar/SimpleNavBar';
import { getCustomerDetails, resetCustomerForm } from 'features/CustomerDetails/customerForm';
import { resetCustomers } from 'features/Customers/customers';
import { getOrderListDetails } from 'features/OrdersList/ordersListForm';
import { ManageCompanyRedirects } from './ManageCompanyRedirects';
import { customersPrefix, customerId, orderListId } from './routes';

const CustomersRoutes: FC<{}> = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const customer = useSelector(getCustomerDetails);
  const orderList = useSelector(getOrderListDetails);

  useEffect(() => {
    return () => {
      dispatch(resetCustomerForm());
      dispatch(resetCustomers());
    };
  }, []);

  return (
    <Switch>
      <Route path={`${path}`}>
        <AppMenuDrawer />
        <ManageCompanyRedirects redirectTo={customersPrefix} />
        <PrivateRoute
          exact
          path={path}
          component={CustomersList}
          navbar={SimpleNavBar}
          navbarTitle={t('customers.list')}
        />
        <PrivateRoute exact path={`${path}/new`} component={CustomerDetails} navbar={SimpleNavBar} navbarBack />
        <PrivateRoute
          exact
          path={`${path}/details${customerId}`}
          component={CustomerDetails}
          navbar={SimpleNavBar}
          navbarTitle={customer?.company_name}
          navbarBack
        />
        <PrivateRoute
          path={`${path}/details${customerId}/orderlist/testreport${orderListId}`}
          component={TestReport}
          navbar={SimpleNavBar}
          navbarTitle={t('testReport.title')}
          navbarBack
        />
        <PrivateRoute
          path={`${path}/details${customerId}/orderlist/finalize${orderListId}`}
          component={FinalizeOrderList}
          navbar={SimpleNavBar}
          navbarTitle={orderList?.short_name}
          navbarBack
        />
        <PrivateRoute
          path={[`${path}/details${customerId}/orderlist/new`, `${path}/details${customerId}/orderlist${orderListId}`]}
          component={LinkToOrderList}
          navbar={SimpleNavBar}
          navbarTitle={orderList?.short_name ? t('orderList.order list details') : t('orderList.order list new')}
          navbarBack
        />
      </Route>
    </Switch>
  );
};

export { CustomersRoutes };
